import { useTranslations } from 'next-intl';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/src/redux/store';
import { userState } from '@/src/redux/userSlice/userSlice';
import { MdAccountCircle } from 'react-icons/md';
import Modal from '@components/Modal';
import { BsExclamationOctagonFill } from 'react-icons/bs';
import AuthenticateBox from '@/src/app/[locale]/profile/components/AuthenticateBox';

export function AuthenticationContent() {
  const f = useTranslations('FirstLoginModal');
  const user: userState = useSelector((state: RootState) => {
    return state.user;
  });
  return (
    <div className='flex flex-col items-center text-white'>
      <span className='mb-2 text-5xl font-semibold uppercase text-brand'>
        {f('titleWarning')}
      </span>
      <div className='my-6 text-center text-lg'>
        {f.rich('advantagesOfAuthentication', {
          header: (chunks) => (
            <h3 className='text-xl font-bold text-brand'>{chunks}</h3>
          ),
          br: () => <br />,
        })}
      </div>
      <div className='mb-6 flex flex-col items-center'>
        <span className='mb-4 text-5xl'>
          <MdAccountCircle />
        </span>
        <span className='mb-1 text-xl font-semibold'>
          {user.firstName} {user.lastName}
        </span>
        <span className='mt-1 flex items-center justify-center gap-1 rounded-xl border border-brand px-8 py-2 text-sm'>
          <span className='text-brand-alt'>
            <BsExclamationOctagonFill />
          </span>{' '}
          {f('notVerified')}
        </span>
        {(user.email || user.cellphone) && (
          <div className='mt-6 flex flex-col items-center'>
            <span>{user.email}</span>
            <span>{user.cellphone}</span>
          </div>
        )}
      </div>
      <AuthenticateBox />
    </div>
  );
}

export default function AuthenticationModal() {
  return (
    <Modal>
      <AuthenticationContent />
    </Modal>
  );
}
